import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import TransactionForm from '../components/TransactionForm';
import ResultDisplay from '../components/ResultDisplay';
import useAccountingApi from '../../../../hooks/useAccountingApi';

const AssetPurchase = () => {
  const [formData, setFormData] = useState({
    description: '',
    amount: '',
    assetType: '',
    purpose: ''
  });
  const [showExamples, setShowExamples] = useState(true);
  const [feedbackSubmitted, setFeedbackSubmitted] = useState(false);
  const { loading, error, getSuggestion, submitFeedback } = useAccountingApi();
  const [result, setResult] = useState(null);

  const examples = [
    '노트북 구매 - 개발팀 업무용',
    '사무실 책상 구매 - 신규 입사자용',
    '업무용 차량 구매 - 영업팀 사용'
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = await getSuggestion({
        ...formData,
        category: 'ASSET',
        transactionType: 'PURCHASE'
      });
      setResult(data);
    } catch (err) {
      console.error('Error:', err);
    }
  };

  const handleFeedback = async (isHelpful) => {
    try {
      await submitFeedback({
        category: 'ASSET',
        isHelpful,
        suggestion: result,
        userInput: formData
      });
      setFeedbackSubmitted(true);
    } catch (err) {
      console.error('Feedback Error:', err);
    }
  };

  const handleReset = () => {
    setFormData({
      description: '',
      amount: '',
      assetType: '',
      purpose: ''
    });
    setResult(null);
    setFeedbackSubmitted(false);
  };

  return (
    <div className="max-w-4xl mx-auto p-6">
      <div className="mb-8">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-2xl font-bold">자산 구매 분개</h2>
          <Link
            to="/services/accounting"
            className="text-gray-600 hover:text-gray-800"
          >
            서비스 선택으로 돌아가기
          </Link>
        </div>

        {/* 입력 폼 */}
        <div className="bg-white rounded-lg shadow-lg p-6">
          <TransactionForm
            formData={formData}
            setFormData={setFormData}
            onSubmit={handleSubmit}
            loading={loading}
            showExamples={showExamples}
            setShowExamples={setShowExamples}
            examples={examples}
            additionalFields={[
              {
                name: 'assetType',
                label: '자산 유형',
                type: 'select',
                options: [
                  { value: 'equipment', label: '비품/설비' },
                  { value: 'vehicle', label: '차량' },
                  { value: 'building', label: '건물' },
                  { value: 'other', label: '기타' }
                ]
              },
              {
                name: 'purpose',
                label: '사용 목적',
                type: 'textarea',
                placeholder: '자산의 사용 목적을 입력해주세요'
              }
            ]}
          />
        </div>

        {/* 에러 메시지 */}
        {error && (
          <div className="mt-4 p-4 bg-red-100 text-red-700 rounded-lg">
            {error}
          </div>
        )}

        {/* 결과 섹션 */}
        {result && (
          <div className="mt-6">
            <ResultDisplay
              result={result}
              onFeedback={handleFeedback}
              feedbackSubmitted={feedbackSubmitted}
            />
            <div className="flex justify-center mt-6">
              <button
                onClick={handleReset}
                className="px-6 py-2 bg-gray-100 text-gray-600 rounded-lg hover:bg-gray-200 transition-colors"
              >
                새로운 분개 추천받기
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AssetPurchase; 